/* tslint:enable:semicolon*/
import { Messages } from '../../codegen/Localize';
import { L10n } from '../L10n/L10n';
import { Module } from '../Module';
import { ILicensingInfo, IProductKeyInfo } from '../ServerApi/types/ILicensingInfo';
import { BrowserTitleService } from '../services/BrowserTitleService';
import { ILicensingInfoWithTotals } from '../services/LicensesService';
import { ServerService } from '../services/ServerService';

export interface ILicensesScope extends ng.IScope {
  licensingInfo: ILicensingInfoWithTotals;  // Comes from AngularDirective scope
  isEmpty: boolean;
  getCoreCountPrep: (productKeyInfo: IProductKeyInfo) => number;
  getCoreCountRegular: (productKeyInfo: IProductKeyInfo) => number;
  getCreatorCount: (productKeyInfo: IProductKeyInfo) => number;
  getCountOrUnlimited: (numCores: number, userCount: number) => string | number;
  getMaintenanceDate: (productKeyInfo: IProductKeyInfo) => string;
  formatExpirationDate: (date: string) => string;
  isCoreBasedLicense: boolean;
  isSeatLicense: boolean;
  shouldShowSubscriptionLicenseBar: boolean;
  hasAnyCoreLicense: boolean;
}

export class LicensesCtrl {

  private static PermanentRegExp = /permanent/i;
  private static TrialRegExp = /trial/i;

  public static $inject = [
    '$scope',
    '$translate',
    'BrowserTitleService',
    'ServerService'
  ];

  constructor(
    $scope: ILicensesScope,
    $translate: ng.translate.ITranslateService,
    BrowserTitleService: BrowserTitleService,
    ServerService: ServerService
  ) {
    BrowserTitleService.setTitleWithTranslatedSpace({translatedSpaceName: Messages.serverSettings_licenses()});

    $scope.isCoreBasedLicense =  $scope.licensingInfo.totalCoreLicenses > 0;
    $scope.hasAnyCoreLicense =  $scope.licensingInfo.totalCoreLicenses > 0 ||  $scope.licensingInfo.totalPrepCoreLicenses > 0;
    $scope.shouldShowSubscriptionLicenseBar = ServerService.shouldShowServerLicensingTierInfo();

    $scope.isEmpty = ! $scope.licensingInfo.productKeyInfos || ! $scope.licensingInfo.productKeyInfos.length;
    $scope.formatExpirationDate = (date: string) => {
      if (!date || LicensesCtrl.TrialRegExp.test(date)) {
        return '';
      } else if (LicensesCtrl.PermanentRegExp.test(date)) {
        return $translate.instant('license_expiration_permanent');
      } else {
        return L10n.localizedDate(date);
      }
    };

    $scope.getCoreCountPrep = (productKeyInfo: IProductKeyInfo) => {
      return productKeyInfo.numPrepCores;
    };

    $scope.getCoreCountRegular = (productKeyInfo: IProductKeyInfo) => {
      return productKeyInfo.numCores;
    };

    $scope.getCreatorCount = (productKeyInfo: IProductKeyInfo) => {
      return Number(productKeyInfo.creatorUserCount);
    };

    $scope.getCountOrUnlimited = (numCores: number, userCount: number) => {
      if(numCores) {
        return $translate.instant('unlimited');
      }
      return Number(userCount);
    };

    $scope.getMaintenanceDate = (productKeyInfo: IProductKeyInfo) => {
      if(LicensesCtrl.PermanentRegExp.test(productKeyInfo.expiration)){
        return L10n.localizedDate(productKeyInfo.maintenance);
      } else {
        return $translate.instant('notApplicable');
      }
    };
  }
}

Module.instance().controller('LicensesCtrl', LicensesCtrl);
